var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 41.1992L99.3091 58.2174V92.2538L70 109.272L40.6909 92.2538L40.6909 58.2174L70 41.1992Z",
    fill: "url(#paint0_linear_1445_37972)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27.9629L71.0052 26.2339C70.3838 25.8726 69.6162 25.8726 68.9948 26.2339L70 27.9629ZM110.655 51.5993H112.655C112.655 50.8869 112.276 50.2283 111.66 49.8702L110.655 51.5993ZM110.655 98.872L111.66 100.601C112.276 100.243 112.655 99.5844 112.655 98.872H110.655ZM70 122.508L68.9948 124.237C69.6162 124.599 70.3838 124.599 71.0052 124.237L70 122.508ZM29.3455 98.872H27.3455C27.3455 99.5844 27.7244 100.243 28.3402 100.601L29.3455 98.872ZM29.3455 51.5993L28.3402 49.8702C27.7244 50.2283 27.3455 50.8869 27.3455 51.5993H29.3455ZM72 74.7629C72 73.6583 71.1046 72.7629 70 72.7629C68.8954 72.7629 68 73.6583 68 74.7629H72ZM68.9948 29.6919L109.649 53.3283L111.66 49.8702L71.0052 26.2339L68.9948 29.6919ZM108.655 51.5993V98.872H112.655V51.5993H108.655ZM109.649 97.143L68.9948 120.779L71.0052 124.237L111.66 100.601L109.649 97.143ZM71.0052 120.779L30.3507 97.143L28.3402 100.601L68.9948 124.237L71.0052 120.779ZM31.3455 98.872V51.5993H27.3455V98.872H31.3455ZM30.3507 53.3283L71.0052 29.6919L68.9948 26.2339L28.3402 49.8702L30.3507 53.3283ZM68 74.7629V122.508H72V74.7629H68Z",
    fill: "#3873FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3818 116.364L18 104.478V46.3077L37.3818 34.1094",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6365 36.4721C44.2473 36.4721 46.3637 34.3557 46.3637 31.7449C46.3637 29.1341 44.2473 27.0176 41.6365 27.0176C39.0257 27.0176 36.9092 29.1341 36.9092 31.7449C36.9092 34.3557 39.0257 36.4721 41.6365 36.4721Z",
    stroke: "white",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6365 123.455C44.2473 123.455 46.3637 121.338 46.3637 118.727C46.3637 116.116 44.2473 114 41.6365 114C39.0257 114 36.9092 116.116 36.9092 118.727C36.9092 121.338 39.0257 123.455 41.6365 123.455Z",
    stroke: "white",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.618 116.364L122 104.478V46.3077L102.618 34.582",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3635 36.4721C95.7527 36.4721 93.6363 34.3557 93.6363 31.7449C93.6363 29.1341 95.7527 27.0176 98.3635 27.0176C100.974 27.0176 103.091 29.1341 103.091 31.7449C103.091 34.3557 100.974 36.4721 98.3635 36.4721Z",
    stroke: "white",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3635 123.455C95.7527 123.455 93.6363 121.338 93.6363 118.727C93.6363 116.116 95.7527 114 98.3635 114C100.974 114 103.091 116.116 103.091 118.727C103.091 121.338 100.974 123.455 98.3635 123.455Z",
    stroke: "white",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 55,
    y: 8,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 73,
    y: 8,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 55,
    y: 23,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 73,
    y: 23,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 55,
    y: 38,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 73,
    y: 38,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 53,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 53,
    width: 12,
    height: 12,
    fill: "#3CE1CD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1445_37972",
    x1: 70,
    y1: 41.1992,
    x2: 70,
    y2: 109.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3873FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon_01.9c845eafecf8f6df8d96402a5df95531.svg";
export { ForwardRef as ReactComponent };